import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useToast } from '@/hooks/use-toast';
import { useAuth } from '@/contexts';
import { fetchSegregacaoCalcular } from '../api/SegregacaoApi';
import type { SegregacaoCalcularPayload } from '../api/types';

export function useSegregacaoCalcular(payload: SegregacaoCalcularPayload | null) {
  const { toast } = useToast();
  const { user } = useAuth();
  const cnpjGestor = user?.cnpj;

  const query = useQuery({
    queryKey: [
      'segregacao-calcular',
      cnpjGestor,
      payload?.CnpjContribuinte,
      payload?.Ano,
      payload?.Mes,
    ],
    queryFn: () => fetchSegregacaoCalcular(payload!),
    enabled: !!payload && !!cnpjGestor,
    staleTime: 60_000,
  });

  useEffect(() => {
    if (!query.error) return;
    toast({
      variant: 'destructive',
      title: 'Erro ao calcular segregação',
      description: 'Não foi possível carregar os dados. Tente novamente.',
    });
  }, [query.error, toast]);

  return query;
}
